(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("babylon-mmd", [], factory);
	else if(typeof exports === 'object')
		exports["babylon-mmd"] = factory();
	else
		root["BABYLONMMD"] = factory();
})((typeof self !== "undefined" ? self : typeof global !== "undefined" ? global : this), () => {
return 